module.exports = __webpack_public_path__ + "a768e7de/img/arrow-left-icon.785c715c.svg";